export default __webpack_public_path__ + "static/media/img_01.532a58c8.png";